import { Chip } from '@mui/material';
import { useTranslate } from 'react-admin';

/**
 * Persistent non-production badge (foundations.md §29). Read from the
 * build mode, never the API host or URL, so it is statically absent from
 * the production bundle. Never rendered in production.
 */
export function EnvironmentBadge() {
  const translate = useTranslate();
  const mode = import.meta.env.MODE;

  if (mode === 'production') return null;

  const label = mode === 'staging' ? translate('pay.appBar.environmentTest') : translate('pay.appBar.environmentLocal');

  return (
    <Chip
      label={label}
      size="small"
      color="warning"
      sx={{ ml: 1.5, height: 20, fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase' }}
    />
  );
}
